import React, { useCallback, useState } from 'react';
import cn from 'classnames';
import Title from 'components/UI/Title';
import Subtitle from 'components/UI/Subtitle';
import CollapseEl from 'components/UI/CollapseEl';
import TagsLayout from './TagsLayout';
import { useTrans } from 'utils/localisation';

import * as styles from './Accordion.module.scss';

function Accordion({ calculatorID, counter, deviceType }) {
  const t = useTrans(['calculator']);
  const [collapse, setCollapse] = useState(false);

  const toggleCollapse = useCallback(() => {
    setCollapse(!collapse);
  }, [collapse]);

  return (
    <>
      <div className={styles.wrapper}>
        <Title tag="h4">{t('resultModalTitle')}</Title>
        <Subtitle className={styles.subtitle}>{t('resultModalSubtitle')}</Subtitle>
      </div>
      <button
        className={cn(styles.collapseButton, collapse && styles.active)}
        onClick={toggleCollapse}
      >
        <span>{t('calculatorCollapseTitle')}</span>
      </button>
      <CollapseEl toggle={collapse}>
        <div className={styles.collapseItems}>
          <TagsLayout calculatorID={calculatorID} counter={counter} deviceType={deviceType} />
        </div>
      </CollapseEl>
    </>
  );
}

export default React.memo(Accordion);
